import {I18n} from "aws-amplify";
import {ErrorMessage} from "./ErrorMessage";

I18n.setLanguage('ja-JP');
I18n.putVocabularies(ErrorMessage);

export const TranslateError = e => {
    console.log(e.name);
    e.message = I18n.get(e.name, 'Unknown Error');
    return e;
}
export default TranslateError;
